export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10099.2a757554.jpg";